<template>
    <div class="status-box">
        <div>
            <template v-if="order.canceled">
                <div class="small">Заказ отменен</div>
                <div class="progress progress-md mt-h mb-1">
                    <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-canceled" style="width: 100%"></div>
                </div>
            </template>
            <template v-else>
                <div :class="'text-' + order.status.class" class="small">{{order.status.name}}</div>
                <div class="progress progress-md mt-h mb-1">
                    <div
                            role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
                            :class="'bg-' + (order.problem ? 'danger' : order.status.class)"
                            class="progress-bar"
                            :style="{ width: progressBarWidth + '%'}"></div>
                </div>
            </template>
            <div>
                <loading v-if="loading" :size="2" :message="false"></loading>
                <div v-else role="group" class="btn-group">
                    <b-btn
                      size="md"
                      v-for="transition in order.transitions"
                      :key="transition.code"
                      :variant="getTransitionClass(transition)"
                      :disabled="(transition.code === 'accept' || transition.code === 'acceptFromConfirmed') && !todayCheck"
                      @click.stop.prevent="beforeSetOrderTransition(transition)"
                    >
                      <span
                        v-b-tooltip.hover
                        :title="(transition.code === 'accept' || transition.code === 'acceptFromConfirmed') && !todayCheck? 'В работу можно перевести только заказы на сегодня или просроченные' : ''">
                        {{transition.name}}
                      </span>
                    </b-btn>
                </div>
                <!--<b-dropdown v-else-if="firstTransition && otherTransitions"-->
                        <!--split-->
                        <!--:text="firstTransition.name"-->
                        <!--:variant="'sm ' + firstTransition.class"-->
                        <!--@click.stop.prevent="beforeSetOrderTransition(firstTransition)"-->
                <!--&gt;-->
                    <!--<b-dropdown-item-->
                            <!--v-if="otherTransitions"-->
                            <!--v-for="transition in otherTransitions"-->
                            <!--:key="transition.code"-->
                            <!--@click.stop.prevent="beforeSetOrderTransition(transition)"-->
                    <!--&gt;{{transition.name}}</b-dropdown-item>-->
                <!--</b-dropdown>-->
                <!--<b-btn v-else-if="firstTransition"  :variant="'sm ' + firstTransition.class"  @click.stop.prevent="beforeSetOrderTransition(firstTransition)">-->
                    <!--{{firstTransition.name}}-->
                <!--</b-btn>-->
            </div>
        </div>
        <div v-if="showSum">
            <div v-if="order.sum">Выручка: <b class="text-success">{{order.sum}}</b> <i class="fa fa-rub"></i> </div>
            <div v-if="order.profit">Прибыль: <b class="text-success">{{order.profit}}</b>  <i class="fa fa-rub"></i>
              <span v-if="commission !== -1" :class="{'commission-warn': commission < 10}" v-b-tooltip.hover title="Рентабельность заказа">({{commissionShow}}%)</span>
            </div>
        </div>
    </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import TWEEN from '@tweenjs/tween.js'
  import moment from 'moment'

  export default{
    props: {
      order: {
        type: Object,
        required: true
      },
      commission: Number,
      showSum: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    computed: {
      commissionShow () {
        return this.commission === 0 ? '<1' : this.commission
      },
      firstTransition: function () {
        if (this.order.transitions.length > 0) {
          let transitions = this.order.transitions
            .map(a => Object.assign({}, a))
            .sort(item => item.default ? -1 : 1)
          return transitions[0]
        } else {
          return false
        }
      },
      otherTransitions: function () {
        if (this.order.transitions.length > 1) {
          let transitions = this.order.transitions
            .map(a => Object.assign({}, a))
            .filter(item => item.code !== this.firstTransition.code)
          return transitions
        } else {
          return false
        }
      },
      ...mapState({
        statuses: state => state.globalStore.statuses
      })
    },
    watch: {
      order: function (newOrder, oldOrder) {
        let vm = this
        let oldValue = {tweeningNumber: ((100 / this.statuses.length) * oldOrder.status.id)}
        let newValue = {tweeningNumber: ((100 / this.statuses.length) * newOrder.status.id)}
        function animate () {
          if (TWEEN.update()) {
            requestAnimationFrame(animate)
          }
        }
        new TWEEN.Tween(oldValue)
          .easing(TWEEN.Easing.Quadratic.Out)
          .to(newValue, 500)
          .onUpdate(function () {
            vm.progressBarWidth = oldValue.tweeningNumber
          })
          .start()
        animate()
      }
    },
    data () {
      return {
        loading: false,
        progressBarWidth: 0,
        todayCheck: true
      }
    },
    methods: {
      beforeSetOrderTransition (transition) {
        switch (transition.code) {
          case 'closing':
            this.$store.dispatch('setEditOrder', this.order)
            this.$store.commit('SET_SHOW_ORDER_MODAL', 'closeOrder')
            break
          case 'cancel':
            this.$store.dispatch('setEditOrder', this.order)
            this.$store.commit('SET_SHOW_ORDER_MODAL', 'cancelOrder')
            break
          case 'problem':
            this.$store.dispatch('setEditOrder', this.order)
            this.$store.commit('SET_SHOW_ORDER_MODAL', 'problemOrder')
            break
          case 'noProblem':
            this.setNoProblem()
            break
          case 'noCancel':
            this.setNoCancel()
            break
          case 'accept':
            this.$store.dispatch('setEditOrder', this.order)
            this.$store.dispatch('setConfirmTransition', transition)
            this.$store.commit('SET_SHOW_ORDER_MODAL', 'transitionOrderConfirm')
            break
          case 'calculate':
            this.$store.dispatch('setEditOrder', this.order)
            this.$store.dispatch('setConfirmTransition', transition)
            this.$store.commit('SET_SHOW_ORDER_MODAL', 'transitionOrderConfirm')
            break
          case 'complete':
            this.$store.dispatch('setEditOrder', this.order)
            this.$store.dispatch('setConfirmTransition', transition)
            this.$store.commit('SET_SHOW_ORDER_MODAL', 'transitionOrderConfirm')
            break
          default:
            this.setOrderTransition(transition.code)
        }
      },
      setOrderTransition (code) {
        this.loading = true
        this.$store.dispatch('setOrderTransition', {
          orderId: this.order.id,
          code: code
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Статус успешно изменен',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при смене статуса заказа: ' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      setNoCancel () {
        this.loading = true
        this.$store.dispatch('cancelOrder', {
          value: false,
          orderId: this.order.id
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Отмена заказа снята',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при отмене заказа:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
      },
      setNoProblem () {
        this.loading = true
        this.$store.dispatch('problemOrder', {
          value: false,
          orderId: this.order.id
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Проблема успешно разрешена',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при решении проблемы:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
      },
//      canOrderUpdateStatus () {
//        if (this.order.status.code === 'closed' && !this.order.canOrderFinanceControl) {
//          return false
//        }
//        return this.order.canOrderUpdateStatus
//      },
      getTransitionClass (transition) {
        if (transition.default) {
          return 'md ' + transition.class
        }
        return 'secondary'
      },
      isClientComeToday: function () {
        let today = moment()
        let date = moment(this.order.date, 'DD.MM.YYYY')
        return today.isSameOrAfter(date)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      this.progressBarWidth = ((100 / this.statuses.length) * this.order.status.sort)
      this.todayCheck = this.isClientComeToday()
      setInterval(() => {
        this.todayCheck = this.isClientComeToday()
      }, 1000 * 60 * 15)
    }
  }
</script>
<style>
    /*.status-box.btn-group{*/
        /*line-height: 0.5;*/
    /*}*/
    /*.btn-status {*/
        /*height: 12px;*/
        /*width: 24px;*/
        /*cursor: pointer;*/
        /*border-radius: 0;*/
    /*}*/
    /*.btn-purple{*/
        /*background: #9585bf;*/
    /*}*/
    /*.btn-purple:hover, .btn-purple-hover:hover{*/
        /*background: #7461aa;*/
    /*}*/
    .text-purple{
        color: #9585bf;
    }
    .text-orange{
        color: #ff6200;
    }
    .bg-orange{
        background-color: #ff6200;
    }
    /*.btn-inverse{*/
        /*background: #303030;*/
    /*}*/
    /*.btn-inverse:hover, .btn-inverse-hover:hover{*/
        /*background: #5a5a5a;*/
    /*}*/
    /*.btn-danger:hover, .btn-danger-hover:hover{*/
        /*background: #b74635;*/
    /*}*/
    /*.btn-warning:hover, .btn-warning-hover:hover{*/
        /*background: #e59729;*/
    /*}*/
    /*.btn-success:hover, .btn-success-hover:hover{*/
        /*background: #87b87f;*/
    /*}*/
    .text-inverse{
        color: #303030;
    }
    .bg-canceled{
        background-color: #b9b9b9;
    }
    .text-canceled{
        color: #b9b9b9;
    }
    /*.btn-default{*/
        /*border: 0;*/
    /*}*/

    span.commission-warn {
      color: #ff2b2b;
      font-weight: 700;
    }
</style>



// WEBPACK FOOTER //
// OrderStatus.vue?052de824